import { SET_FONT, SET_DESIGN } from "../ActionTypes"
import { CardOrientation, TransactionDateTypes } from "../../utils/constants"

const initialState = {
  fontFamily: "Inter",
  primaryColor: "#0D286C",
  secondaryColor: "#53B7ED",
  toastColor: "#FFFFFF",
  toastBgColor: "#303030",
  cardDesignUrl: null,
  cardOrientation: CardOrientation.VERTICAL,
  title: "",
  titleColor: "#FFFFFF",
  headerBackgroundColor: "#000000",
  backgroundColor: "#FFFFFF",
  widgetBackgroundColor: "#FFFFFF",
  appTextColor: "#303030",
  deskTopBackgroundColor: "#FFFFFF",
  transactionDateType: TransactionDateTypes.TRANSACTION_DATE,
  iconOverlay: "NONE",
  iconOverlayImageUrl: "",
  virtualCardAnimation: "NONE",
  transactionViewType: "ALL",
}

const ThemeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FONT:
      return {
        ...state,
        fontFamily: action.payload.fontFamily,
      }
    case SET_DESIGN:
      return {
        ...state,
        primaryColor: action.payload.primaryColor,
        secondaryColor: action.payload.secondaryColor,
        cardDesignUrl: action.payload.cardDesignUrl,
        cardOrientation: action.payload.cardOrientation,
        title: action.payload.title,
        titleColor: action.payload.titleColor,
        widgetBackgroundColor: action.payload.widgetBackgroundColor,
        appTextColor: action.payload.appTextColor,
        headerBackgroundColor: action.payload.headerBackgroundColor,
        backgroundColor: action.payload.backgroundColor,
        transactionDateType: action.payload.transactionDateType,
        toastColor: action.payload.toastColor,
        toastBgColor: action.payload.toastBgColor,
        iconOverlay: action.payload.iconOverlay,
        iconOverlayImageUrl: action.payload.iconOverlayImageUrl,
        virtualCardAnimation: action.payload.virtualCardAnimation,
        transactionViewType: action.payload.transactionViewType,
      }
    default:
      return state
  }
}

export default ThemeReducer
